import React, {Component} from "react";
import ModuleVideoListItem from "./ModuleVideoListItem.js";
import {connect} from "react-redux";

class ModuleVideoMultimediaWeek extends Component {
    static compare(a, b) {
        let comp = 0;
        let aname = a.props.week.name;
        let bname = b.props.week.name;
        if (/^[0-9]/.test(aname) && /^[0-9]/.test(bname)) {
            let aidx = parseFloat(aname);
            let bidx = parseFloat(bname);
            comp = aidx - bidx;
        }
        if (comp !== 0)
            return comp;
        // if empty videos in files, I assume this is new week and no video yet
        if (!a.props.week.files.length)
            return 1;
        else if (!b.props.week.files.length)
            return -1;
        return +new Date(a.props.week.files[0].time) - +new Date(b.props.week.files[0].time);
    }

    render() {
        let id = this.props.midx + this.props.widx;
        let classes = 'collapse ' + (this.props.collapse[id] ? 'show' : '');
        return (
            <div className="card">
                <div className="card-header">
                    <h5 className="week-title-h5 mb-0">
                        <a data-toggle="collapse" href={'#' + id} aria-controls={id} aria-expanded="false">
                            {this.props.week.name}
                        </a>
                    </h5>
                </div>
                <div id={id} className={classes}>
                    <div className="card-block">
                        {this.props.week.files.map(v =>
                            <ModuleVideoListItem {...v} key={v.ID}/>
                        ).sort((a, b) => ModuleVideoListItem.compare(a, b))}
                    </div>
                </div>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        collapse: state.collapse
    };
};
export default connect(mapStateToProps)(ModuleVideoMultimediaWeek);


// WEBPACK FOOTER //
// ./src/componentsBody/ModuleVideoMultimediaWeek.js